import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import student2 from "../assets/balcony.jpg";
import API_ROUTES from "../constants/apis";
import axios from "axios";
import Residence from "./Residence";

function SearchResidence() {
  const [searchQuery, setSearchQuery] = useState("");
  const [hostels, setHostels] = useState([]);

  const [residences, setResidences] = useState([]);

  useEffect(() => {
    axios
      .get(API_ROUTES.HOSTELS)
      .then((response) => {
        setResidences(response.data);
      })
      .catch((error) => {
        console.error("Error fetching residences:", error);
      });
  }, []);

  const handleSearch = async () => {
    try {
      const response = await fetch(
        `${API_ROUTES.SEARCH}?university=${searchQuery}`
      );

      if (response.ok) {
        const data = await response.json();
        setHostels(data);
      } else {
        console.error("Search request failed with status:", response.status);
      }
    } catch (error) {
      console.error("Search request failed:", error);
    }
  };
  return (
    <div>
      <Navbar />
      <div
        className="mt-28 pt-2 h-25vh flex justify-center items-center"
        style={{
          backgroundImage: `linear-gradient(to left, rgba(255,255,255,0), rgba(255,255,255,1)), url(${student2})`,
          backgroundSize: "cover",
          backgroundPosition: "right",
          backgroundBlendMode: "multiply",
        }}
      >
        <div>
          <input
            type="search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search by University"
            className="rounded-l-md p-2 border-2 border-red-500 focus:outline-sky-600 text-blue-950"
          />

          <button
            onClick={handleSearch}
            className="bg-red-500 p-2 rounded-r-md text-white border-2 border-red-500"
          >
            Search
          </button>
        </div>
      </div>
      <div>
        {hostels.length > 0 && (
          <p className="text-center text-xl text-green-700 font-bold p-4">
            {`${hostels.length} Hostels found around the searched University`}
          </p>
        )}

        <div className="pt-2 grid grid-cols-1 lg:grid-cols-2 gap-4 overflow-y-auto">
          {hostels.length > 0 ? (
            hostels.map((residence) => (
              <Residence key={residence.id} residence={residence} />
            ))
          ) : residences.length > 0 ? (
            residences.map((residence) => (
              <Residence key={residence.id} residence={residence} />
            ))
          ) : (
            <p className="text-center text-xl text-red-700 font-bold p-4">
              No Hostels posted yet
            </p>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SearchResidence;
